var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoulderEpaulette01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-121,.cls-120{fill:#fff;stroke:#010101;stroke-miterlimit:10;}.cls-121{stroke-width:2.66px;}.cls-120{stroke-width:0.89px;stroke-dasharray:3.6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M86.43,167.4c15.77-1.5,41.76-6.25,57.53-7.75,9.9,7.5,18.31,21.54,38,34.24,72.22,46.65,104.36,52.05,137.58,90.61,10.45,12.14,24,31.45,33.78,60.8-6.39,4.13-21.54,10.92-27.92,15.05-5.14-11.2-5.08-30-19.37-46.57-10.58-12.25-31.36-32.95-94.59-60.8-28.16-12.41-65.62-23.82-115.06-35.72C93.72,201.87,89.06,182.79,86.43,167.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M326.67,356.47c-1-2.83-1.83-6.08-2.74-9.7-2.6-10.27-5.84-23.06-15.92-34.73-12.62-14.6-34.88-34.78-95.52-61.49-27.22-12-63.42-23.27-113.83-35.46-1.29-7.31-3-15.43-4.67-23.31-1.57-7.43-3.19-15.09-4.45-22,7.55-.83,16.94-2.23,26.05-3.59,9.78-1.47,19.88-3,27.57-3.76a105,105,0,0,1,10.15,10c6.54,7,14.69,15.69,27.18,23.76,27,17.45,48.83,29.36,66.37,38.93C277,251.53,297,262.42,317.49,286.24c14,16.24,24.95,35.71,32.6,57.91-3.15,1.84-7.62,4.11-12,6.31C334.06,352.52,329.89,354.63,326.67,356.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.29,186.32v4.61c0,5.65-6.61,10.24-14.75,10.24s-14.76-4.59-14.76-10.24v-4.61a7.91,7.91,0,0,1,2-5.15c2.56-3,7.31-5.09,12.76-5.09s10.19,2,12.75,5.09A8,8,0,0,1,139.29,186.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoulderEpaulette01);
export default __webpack_public_path__ + "static/media/Shoulder Epaulette-01.e4d9978e3db446a53de3ded6c12def5a.svg";
export { ForwardRef as ReactComponent };